import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getApiBaseUrl } from "../../config";

const baseQuery = fetchBaseQuery({
    baseUrl: `${getApiBaseUrl()}/contacts`,
    credentials: "include",
    prepareHeaders: (headers, { getState }) => {
        const user = getState().user?.currentUser;
        if (user?.id) {
            headers.set("userid", user.id);
        }
        return headers;
    },
});

export const contactPersonApi = createApi({
    reducerPath: "contactPersonApi",
    baseQuery,
    tagTypes: ["ContactPerson"],
    endpoints: (builder) => ({
        getContactPersons: builder.query({
            query: () => "",
            transformResponse: (response) => response.data || response,
            providesTags: ["ContactPerson"],
        }),
        getContactPersonById: builder.query({
            query: (id) => `${id}`,
            transformResponse: (response) => response.data || response,
            providesTags: ["ContactPerson"],
        }),
        createContactPerson: builder.mutation({
            query: (data) => ({
                url: "",
                method: "POST",
                body: data,
            }),
            transformResponse: (response) => response.data || response,
            invalidatesTags: ["ContactPerson"],
        }),
        updateContactPerson: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${id}`,
                method: "PUT",
                body: data,
            }),
            transformResponse: (response) => response.data || response,
            invalidatesTags: ["ContactPerson"],
        }),
        deleteContactPerson: builder.mutation({
            query: (id) => ({
                url: `${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["ContactPerson"],
        }),
        getContactsByCompanyProfile: builder.query({
            query: (companyProfileId) => `company/${companyProfileId}`,
            providesTags: ["ContactPerson"],
        }),
        bulkUpdateContacts: builder.mutation({
            query: (data) => ({
                url: "bulk-update",
                method: "POST",
                body: data,
            }),
            transformResponse: (response) => response.data || response,
            invalidatesTags: ["ContactPerson"],
        }),
    }),
});

export const {
    useGetContactPersonsQuery,
    useGetContactPersonByIdQuery,
    useCreateContactPersonMutation,
    useUpdateContactPersonMutation,
    useDeleteContactPersonMutation,
    useGetContactsByCompanyProfileQuery,
    useBulkUpdateContactsMutation,
} = contactPersonApi;
